import { jsx as _jsx } from "react/jsx-runtime";
import { Form, DatePicker } from 'antd';
import { CalendarIcon } from 'assets/icons';
import dayjs from 'dayjs';
var FormDatePicker = function (props) {
    var _a;
    var MIN_AGE = (_a = props.minAge) !== null && _a !== void 0 ? _a : 0;
    var defaultBirthDate = dayjs().subtract(MIN_AGE, 'year');
    return (_jsx(Form.Item, { label: props.label, name: props.name, className: props.formClasses || 'form-item body---14pt-R', rules: props.rules, hasFeedback: true, initialValue: props.initialValue, children: _jsx(DatePicker, { className: "input-border caledar-size space-item", suffixIcon: _jsx(CalendarIcon, {}), inputReadOnly: true, placeholder: props.placeHolder, onChange: props.onChange, defaultPickerValue: defaultBirthDate, disabledDate: function (current) {
                return Boolean(props.lockFutureDates) && current && current.isAfter(defaultBirthDate, 'day');
            } }) }));
};
export default FormDatePicker;
